import { Modal, Button, Alert } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { useAxios } from 'configs/requests';
import { Loading } from 'components/Fetch';

interface ICancelOrderModalProps {
  device: IDeviceListItem;
  onClose: () => void;
  onSuccess: () => void;
}

const CancelOrderModal = ({ device, onClose, onSuccess }: ICancelOrderModalProps) => {
  const intl = useIntl();
  const purchaseOrderId = device.purchaseOrder?.purchaseOrderId;
  const displayId = device.purchaseOrder?.displayId;

  const [{ loading, error }, cancelOrder] = useAxios<void>(
    {
      url: `/clinician-gateway/device/order/${purchaseOrderId ?? ''}`,
      method: 'DELETE'
    },
    { manual: true }
  );

  const handleConfirm = async () => {
    try {
      await cancelOrder();
      onSuccess();
      onClose();
    } catch {
      // error surfaced via useAxios `error` state above
    }
  };

  return (
    <Modal show onHide={onClose} data-test="cancel-order-modal">
      {loading ? (
        <Loading className="m-5" />
      ) : (
        <>
          <Modal.Header closeButton>
            <Modal.Title>{intl.formatMessage({ id: 'confirmCancelOrderKey' })}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {error ? (
              <Alert variant="danger" className="mb-0">
                {intl.formatMessage(
                  { id: 'orderCannotBeCancelledKey' },
                  { displayId: displayId ?? '' }
                )}
              </Alert>
            ) : (
              intl.formatMessage({ id: 'orderWillBeCancelledKey' }, { displayId: displayId ?? '' })
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onClose} data-test="cancel-order-dismiss">
              {intl.formatMessage({ id: 'Cancel' })}
            </Button>
            <Button
              variant="primary"
              onClick={handleConfirm}
              disabled={!purchaseOrderId || !!error}
              data-test="cancel-order-confirm"
            >
              {intl.formatMessage({ id: 'cancelOrderKey' })}
            </Button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default CancelOrderModal;
